const CART_PAG_RPP = 'resideo:cart:pagination:rows';
const CART_PAG_PAGE = 'resideo:cart:pagination:page';

/**
 * @returns {HTMLTableRowElement[]}
 */
function getTableBodyRows() {
  // Prefer <cart-table> (pagination lives inside it, sibling to #cart-form). Tbody class may differ after morph.
  const cart = document.querySelector('cart-table');
  if (cart) {
    const a = cart.querySelectorAll('tbody tr.rs-table-body__row');
    if (a.length) return /** @type {HTMLTableRowElement[]} */ (Array.from(a));
  }
  const b = document.querySelectorAll('#cart-form .cart-table__body tr.rs-table-body__row, .cart-form tbody tr.rs-table-body__row');
  if (b.length) return /** @type {HTMLTableRowElement[]} */ (Array.from(b));
  return /** @type {HTMLTableRowElement[]} */ (Array.from(document.querySelectorAll('.cart-table tbody tr.rs-table-body__row')));
}

/**
 * @returns {number | null}
 */
function readRppFromSession() {
  try {
    const s = window.sessionStorage.getItem(CART_PAG_RPP);
    if (s == null) return null;
    const v = parseInt(s, 10);
    if (Number.isNaN(v) || v < 1) return null;
    return v;
  } catch {
    return null;
  }
}

/**
 * @returns {number | null}
 */
function readPageFromSession() {
  try {
    const s = window.sessionStorage.getItem(CART_PAG_PAGE);
    if (s == null) return null;
    const v = parseInt(s, 10);
    if (Number.isNaN(v) || v < 1) return null;
    return v;
  } catch {
    return null;
  }
}

/**
 * @returns {number}
 */
function readRppFromActiveOptionInDom() {
  const active = document.querySelector('.rs-cart-pagination__rows-option.rs-active');
  if (active) {
    const n = parseInt(/** @type {HTMLElement} */ (active).getAttribute('value') || '10', 10);
    if (!Number.isNaN(n) && n > 0) return n;
  }
  return 10;
}

/**
 * @param {number} r
 * @param {number} p
 */
function persistState(r, p) {
  try {
    window.sessionStorage.setItem(CART_PAG_RPP, String(r));
    window.sessionStorage.setItem(CART_PAG_PAGE, String(p));
  } catch {
    /* ignore */
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (typeof window.wireCartPaginationRowsSelect === 'function') {
    window.wireCartPaginationRowsSelect();
  }

  const fromSessionRpp = readRppFromSession();
  const fromSessionPage = readPageFromSession();

  let currentPage = fromSessionPage != null ? fromSessionPage : 1;
  let rowsPerPage = fromSessionRpp != null ? fromSessionRpp : readRppFromActiveOptionInDom();

  function getControls() {
    return {
      pageInfo: document.querySelector('.rs-cart-pagination__info'),
      prevBtn: document.getElementById('cart-pagination-prev'),
      nextBtn: document.getElementById('cart-pagination-next'),
    };
  }

  function renderPage(/** @type {boolean} */ announce = false) {
    const rows = getTableBodyRows();
    const {pageInfo, prevBtn, nextBtn} = getControls();
    const totalItems = rows.length;
    const totalPages = Math.max(1, Math.ceil(totalItems / rowsPerPage));

    if (currentPage > totalPages) currentPage = totalPages;
    if (currentPage < 1) currentPage = 1;

    const startIndex = (currentPage - 1) * rowsPerPage + 1;
    const endIndex = startIndex + rowsPerPage - 1;

    rows.forEach((row, i) => {
      const position = i + 1;
      if (position >= startIndex && position <= endIndex) {
        row.classList.remove('rs-hidden');
      } else {
        row.classList.add('rs-hidden');
      }
    });

    const endShown = endIndex < totalItems ? endIndex : totalItems;
    const startShown = totalItems === 0 ? 0 : startIndex;
    const rangeText = window.__t('range_of_total', {start: startShown, end: endShown, total: totalItems});
    if (pageInfo) {
      pageInfo.textContent = rangeText;
    }
    if (announce) {
      const statusEl = document.getElementById('cart-pagination-status');
      if (statusEl) {
        statusEl.textContent = rangeText;
      }
    }
    if (prevBtn) prevBtn.disabled = currentPage === 1;
    if (nextBtn) nextBtn.disabled = currentPage === totalPages;

    persistState(rowsPerPage, currentPage);
  }

  function syncOptionUIFromState() {
    const val = String(rowsPerPage);
    const opts = document.querySelectorAll('.rs-cart-pagination__rows-option[role="option"]');
    opts.forEach((btn) => {
      if (!(btn instanceof HTMLButtonElement)) return;
      const v = btn.getAttribute('value');
      const match = v === val;
      btn.classList.toggle('rs-active', match);
      btn.setAttribute('aria-selected', match ? 'true' : 'false');
    });
    const rowSelectBtn = document.querySelector('.rs-cart-pagination__rows-button');
    const span = rowSelectBtn?.querySelector('span');
    if (span) {
      span.textContent = window.__t('show_count_rows', {count: val});
    }
    if (rowSelectBtn instanceof HTMLButtonElement && typeof window.applyCartPaginationRowsAccessibleName === 'function') {
      const expanded = rowSelectBtn.closest('.rs-cart-pagination__rows-select')?.classList.contains('is-open') === true;
      window.applyCartPaginationRowsAccessibleName(rowSelectBtn, expanded);
    }
    renderPage();
  }

  /** Document capture: runs before listbox `stopPropagation` in bubble, and after cart section morph (no stale per-node listeners). */
  function onPaginationControlClick(/** @type {MouseEvent} */ e) {
    const t = e.target;
    if (!(t instanceof Node) || !t.closest) return;

    const el = /** @type {Element} */ (t instanceof Element ? t : t.parentElement);
    if (!el) return;

    const hitNext = el.id === 'cart-pagination-next' || t.closest?.('#cart-pagination-next');
    if (hitNext) {
      e.preventDefault();
      const r = getTableBodyRows();
      const totalPages = Math.max(1, Math.ceil(r.length / rowsPerPage));
      if (currentPage < totalPages) {
        currentPage += 1;
        renderPage(true);
      }
      return;
    }

    const hitPrev = el.id === 'cart-pagination-prev' || t.closest?.('#cart-pagination-prev');
    if (hitPrev) {
      e.preventDefault();
      if (currentPage > 1) {
        currentPage -= 1;
        renderPage(true);
      }
      return;
    }

    const opt = t.closest?.('.rs-cart-pagination__rows-option[role="option"]');
    if (opt instanceof HTMLButtonElement) {
      const v = parseInt(opt.getAttribute('value') || '10', 10);
      if (Number.isNaN(v) || v < 1) return;
      e.preventDefault();
      // Do not stopPropagation: listener is on document in capture; stopping can block the target phase.
      rowsPerPage = v;
      currentPage = 1;
      document.querySelectorAll('.rs-cart-pagination__rows-option[role="option"]').forEach((b) => {
        if (!(b instanceof HTMLButtonElement)) return;
        const match = b === opt;
        b.classList.toggle('rs-active', match);
        b.setAttribute('aria-selected', match ? 'true' : 'false');
      });
      const rowSelectBtn = document.querySelector('.rs-cart-pagination__rows-button');
      const rowSpan = rowSelectBtn?.querySelector('span');
      if (rowSpan) {
        rowSpan.textContent = window.__t('show_count_rows', {count: String(v)});
      }
      if (rowSelectBtn instanceof HTMLButtonElement && typeof window.applyCartPaginationRowsAccessibleName === 'function') {
        window.applyCartPaginationRowsAccessibleName(rowSelectBtn, false);
      }
      const root = opt.closest?.('.rs-cart-pagination__rows-select');
      if (root instanceof HTMLElement) {
        root.classList.remove('is-open');
        const cmb = root.querySelector('.rs-cart-pagination__rows-button');
        cmb?.classList.remove('is-open');
        if (cmb instanceof HTMLButtonElement && typeof window.applyCartPaginationRowsAccessibleName === 'function') {
          window.applyCartPaginationRowsAccessibleName(cmb, false);
        }
      }
      renderPage();
    }
  }

  document.addEventListener('click', onPaginationControlClick, true);

  function afterCartOrRowsChange() {
    // Section morph (cart:update) replaces the footer; re-read state from session first, else new server markup.
    const sR = readRppFromSession();
    if (sR != null) {
      rowsPerPage = sR;
    } else {
      rowsPerPage = readRppFromActiveOptionInDom();
    }
    const sP = readPageFromSession();
    if (sP != null) {
      currentPage = sP;
    } else {
      currentPage = 1;
    }

    // Do not re-call wireCartPaginationRowsSelect here: each call adds another document mousedown
    // listener. After morph, rows-per-page options still work via onPaginationControlClick (capture).
    syncOptionUIFromState();
  }

  document.addEventListener('cart:rows-updated', afterCartOrRowsChange);
  document.addEventListener('cart:update', afterCartOrRowsChange);

  syncOptionUIFromState();
});
